

const ElementCollection = require('./index');

module.exports = function (selector, context) {
  return new ElementCollection(selector, context);
};



// WEBPACK FOOTER //
// ./src/js/common-js-helpers/elementCollection/shorthandSelector.js